import { If } from '@itau-loans-www/components'
import IconCheck from '@mobi/ds/static/icons/outlined/check.svg'

import './pending-data-input-wrapper.scss'

const InputWrapper = ({
  children,
  formOkText,
  formOkCondition,
  formShowCondition
}) => {
  return (
    <If
      condition={formShowCondition}
      renderIf={
        <div
          className={
            formOkCondition
              ? 'pending-data__input'
              : 'pending-data__input--error'
          }
        >
          {children}
        </div>
      }
      renderElse={
        <div className="pending-data__input-completed">
          <strong className="pending-data__input-completed-text">
            {formOkText}
          </strong>
          <div className="pending-data__input-completed-icon">
            <IconCheck />
          </div>
        </div>
      }
    />
  )
}

export default InputWrapper
